import script from "./SetupUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetupUser.vue?vue&type=script&lang=ts&setup=true"

import "./SetupUser.vue?vue&type=style&index=0&id=2751c78c&lang=scss&scoped=true"
import "./SetupUser.vue?vue&type=style&index=1&id=2751c78c&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2751c78c"]])

export default __exports__